import { render, staticRenderFns } from "./IndicatorInfos.vue?vue&type=template&id=b109667a&scoped=true"
import script from "./IndicatorInfos.vue?vue&type=script&lang=ts"
export * from "./IndicatorInfos.vue?vue&type=script&lang=ts"
import style0 from "./IndicatorInfos.vue?vue&type=style&index=0&id=b109667a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b109667a",
  null
  
)

export default component.exports